import Modal from '@mui/material/Modal';
import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@mui/material';
import { fontSize, fontWeight, useTheme } from '@mui/system';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Cancel } from '../../assets/icons';
import useScreenSize from '../../hooks/useScreenSize';
import { device } from '../../utils/device';
import TextView from '../TextView';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Button from '../Button';
import Input from '../Input';

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
  width: 50vw;

  @media (${device.mobilePortrait}) {
    width: 90vw;
    max-width: 480px;
  }

  @media (${device.mobileLandscape}) {
    width: 70vw;
    max-width: 550px;
  }
`;

const StyledImage = styled.img`
  height: 5rem;
  width: 5rem;
  margin-bottom: 1rem;
  margin-top: 1rem;

  @media (min-width: 768px) {
    height: 6rem;
    width: 6rem;
  }

  @media (min-width: 1024px) {
    height: 7rem;
    width: 7rem;
  }
`;

const ButtonContainer = styled.div`
  width: 90%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* 3 columns */
  grid-gap: 20px;
  margin-bottom: 20px;
  align-items: center;

  @media (${device.mobilePortrait}) {
    width: 100%;
    grid-gap: 10px;
  }
`;

const CloseIcon = styled.div`
  position: absolute;
  z-index: 100;
  right: 24px;
  cursor: pointer;
`;

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '40%',
    maxHeight: '80%',
    overflowY: 'auto',
    borderRadius: 10,
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '16px',
    lineHeight: '20px',
    marginBottom: '20px',
    borderRadius: '4px',
    border: '1px solid #E1E1E1', // Default border
    '&:focus': {
      outline: 'none',
      borderColor: '#ccc', // Optional: change border color on focus
    },
  },
  visibilityToggle: {
    cursor: 'pointer',
    position: 'absolute',
    right: '10px',
    top: '6px',
  },
  errorText: {
    color: 'red',
    fontSize: '14px',
    marginTop: '8px',
  },
}));

const BetaAmbassadorModal = ({ isOpen, onClose, onAccess }) => {
  const { isMobileLandscape, isMobilePortrait } = useScreenSize();
  const theme = useTheme();
  const dispatch = useDispatch();
  let nav = useNavigate();

  const isMobile = isMobileLandscape || isMobilePortrait;
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleCancel = () => {
    nav('/login');
  };

  const handleConfirm = () => {
    console.log(password, 'pepepepepepepepepepe');
    if (password === 'iYugaAccess108!') {
      toast.success('Success!');
      onClose();
    } else {
      toast.error('Password incorrect!');
    }
  };

  const handleClose = () => {
    nav('/login');
  };

  const [password, setPassword] = useState('');

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
  };
  const classes = useStyles();

  return (
    <StyledModal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="general-dialog-title"
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Light transparent background
        },
      }}
    >
      <ModalContainer>
        <CloseIcon>
          <Cancel onClick={handleClose} />
        </CloseIcon>
        <TextView
          variant="largeTitle"
          style={{
            marginTop: '20px',
          }}
        >
          {/* iYuga Beta coming soon! */}
          Enjoy Beta 2.0!
        </TextView>

        <div
          style={{
            height: '10px',
            borderTop: '1px solid gray',
            width: '90%',
            margin: '20px 0px',
          }}
        ></div>

        <TextView variant={isMobile ? 'text' : 'largeText'} style={{ fontWeight: 500 }}>
          Ambassadors, Investors, and Corporate Partners enter password for access:
        </TextView>

        <div
          style={{
            position: 'relative',
            width: isMobile ? '100%' : '50%',
            marginTop: '20px',
          }}
        >
          <Input
            type={'password'}
            value={password}
            onChange={handlePasswordChange}
            variant={'secondary'}
          />
          <Button onClick={handleConfirm}>Submit</Button>
          <TextView
            onClick={onAccess}
            style={{
              fontSize: '14px',
              fontWeight: '400',
              color: '#8F38EF',
              cursor: 'pointer',
              marginTop: '10px',
            }}
          >
            Don't have password?
          </TextView>
        </div>

        {/* <ButtonContainer>
          <TextView
            onClick={handleCancel}
            style={{ fontSize: '16px', fontWeight: '400', color: '#8F38EF', cursor: 'pointer' }}
          >
            Cancel
          </TextView>
      
          <Button variant="outlined" onClick={onAccess} fullWidth={fullScreen}>
            Request Access
          </Button>

          <Button onClick={handleConfirm} fullWidth={fullScreen}>
            Submit
          </Button>
        </ButtonContainer> */}
      </ModalContainer>
    </StyledModal>
  );
};

export default BetaAmbassadorModal;
